/*
 * Pont entre l'icône panier du thème et le tiroir de l'app Moon Bundle.
 *
 * L'app injecte `cart-drawer:not(moonbundle-cart-drawer) { display: none !important }`,
 * ce qui masque le tiroir natif du thème. L'icône panier continuait pourtant de l'ouvrir :
 * le clic ajoutait `is-open` sur un élément invisible et bloquait le scroll de la page.
 *
 * On redirige donc `open()` / `close()` du tiroir du thème vers celui de Moon Bundle.
 * Si l'app est désactivée ou désinstallée, le tiroir natif reprend la main tout seul.
 */
(function () {
  function moonDrawer() {
    return document.querySelector('moonbundle-cart-drawer-block');
  }

  function openMoon() {
    var drawer = moonDrawer();
    if (drawer && typeof drawer.open === 'function') {
      drawer.open();
      return true;
    }
    if (typeof window.openMoonBundleCartDrawer === 'function' && drawer) {
      window.openMoonBundleCartDrawer();
      return true;
    }
    return false;
  }

  function closeMoon() {
    var drawer = moonDrawer();
    if (drawer && typeof drawer.close === 'function') {
      drawer.close();
      return true;
    }
    return false;
  }

  function patch() {
    var CartDrawer = customElements.get('cart-drawer');
    if (!CartDrawer || CartDrawer.moonBridgeApplied) return !!CartDrawer;

    var nativeOpen = CartDrawer.prototype.open;
    var nativeClose = CartDrawer.prototype.close;

    CartDrawer.prototype.open = function () {
      if (openMoon()) return;
      return nativeOpen.apply(this, arguments);
    };

    CartDrawer.prototype.close = function () {
      if (closeMoon()) return;
      return nativeClose.apply(this, arguments);
    };

    CartDrawer.moonBridgeApplied = true;
    return true;
  }

  if (!patch()) {
    customElements.whenDefined('cart-drawer').then(patch);
  }

  // Filet de sécurité : si le tiroir du thème n'existe pas sur la page (gabarit sans
  // `cart-drawer-group`), l'icône enverrait vers /cart. On ouvre Moon Bundle à la place.
  document.addEventListener(
    'click',
    function (event) {
      var icon = event.target.closest && event.target.closest('cart-icon');
      if (!icon) return;
      if (document.querySelector('cart-drawer')) return;
      if (openMoon()) {
        event.preventDefault();
        event.stopPropagation();
      }
    },
    true
  );
})();
